const hasIntersection = (arrA = [], arrB = []) => {
   let retval = false;

   if (arrA && arrB) {
      for (let i = 0; i < arrA.length; ++i) {
         if (arrB.indexOf(arrA[i]) > -1) {
            retval = true;
            break;
         }
      }
   }

   return retval;
};

// Returns A - B
const getDifference = (arrA = [], arrB = []) => {
   if (!Array.isArray(arrA) || !Array.isArray(arrB)) {
      throw new Error("Invalid argument type.");
   }

   return arrA.filter((x) => !arrB.includes(x));
};

export default {
   hasIntersection,
   getDifference,
};
